export default __webpack_public_path__ + "static/media/logo-idream.b8d117d3.svg";